import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Alert,
} from "reactstrap";
import { Lista } from "./Lista";
import { Link } from "react-router-dom";
import { DatosSesion } from "../../../Components/Common/DatosSesion";

const ServicioDeEntregaListar = () => {
  document.title = "Lista de Plantillas de Mensajes | Farme";
  const perfil = DatosSesion("perfil");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {perfil === "Administrador" ||
          perfil === "Farmacia" ||
          perfil === "MyHealth" ? (
            <>
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardHeader className="border-0">
                      <div className="d-md-flex align-items-center">
                        <h5 className="card-title mb-3 mb-md-0 flex-grow-1">
                          Plantillas de Mensajes
                        </h5>
                        <div className="flex-shrink-0">
                          <div className="d-flex gap-1 flex-wrap">
                            <Link to="/plantillas-mensajes/crear">
                              <Button
                                color="success"
                                type="button"
                                className="add-btn"
                                data-bs-toggle="modal"
                                id="create-btn"
                                data-bs-target="#showModal"
                              >
                                <i className="ri-add-line align-bottom me-1"></i>{" "}
                                Crear Plantilla de Mensaje
                              </Button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <Lista />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <Alert color="danger">
              No tienes permisos para ver esta página.
            </Alert>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ServicioDeEntregaListar;
